import script from "./LanguageSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSetting.vue?vue&type=script&setup=true&lang=js"

import "./LanguageSetting.vue?vue&type=style&index=0&id=02e30a19&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02e30a19"]])

export default __exports__